import { BaSeTheme } from '@base/react';
import React from 'react';

export function handleModalRedirect({
  title,
  titleOnSuccess = 'Aviso de redirecionamento',
  titleOnError = 'Erro',
  content = '',
  msgOnSuccess = 'Você será redirecionado para a página de edição.',
  msgOnError = 'Houve um erro ao tentar realizar essa ação, tente novamente.',
  onConfirmClick = () => {},
  onCancelClick = () => {},
  onFinish = () => {},
  showModal = (config) => {},
}) {
  const labelConfirm = 'Sim';
  const labelOk = 'OK';
  const labelCancel = 'Não';

  const successResponseConfig = {
    actions: [
      {
        action: labelOk,
        type: 'primary',
        color: BaSeTheme.colors.feedbackInterface.sucesso20,
      },
    ],
    title: titleOnSuccess,
    titleColor: BaSeTheme.colors.institucionais.cinzaSebrae45,
    dismissable: true,
    content: () => (
      // <BaSeParagraph
      //   isBold={true}
      //   color={BaSeTheme.colors.institucionais.cinzaSebrae45}
      // >
      //   {msgOnSuccess}
      // </BaSeParagraph>
      <p>{msgOnSuccess}</p>
    ),
    onChooseAction: () => onFinish(),
  };
  const errorResponseConfig = {
    actions: [
      {
        action: labelOk,
        type: 'primary',
        color: BaSeTheme.colors.feedbackInterface.informacao,
      },
    ],
    title: titleOnError,
    titleColor: BaSeTheme.colors.feedbackInterface.erro45,
    dismissable: true,
    content: () => (
      // <BaSeParagraph
      //   isBold={true}
      //   color={BaSeTheme.colors.institucionais.cinzaSebrae45}
      // >
      //   {msgOnError}
      // </BaSeParagraph>

      <p>{msgOnError}</p>
    ),
    onChooseAction: () => onCancelClick(),
  };

  const actionsMap = {
    [labelConfirm]: async () => {
      try {
        await onConfirmClick();
        showModal(successResponseConfig);
      } catch (e) {
        showModal(errorResponseConfig);
      }
    },
    [labelCancel]: () => onCancelClick(),
  };

  const actions = [
    {
      action: labelConfirm,
      type: 'primary',
      color: BaSeTheme.colors.feedbackInterface.sucesso20,
    },
    {
      action: labelCancel,
      type: 'primary',
      color: BaSeTheme.colors.feedbackInterface.erro45,
    },
  ];

  const config = {
    actions,
    title: title,
    titleColor: BaSeTheme.colors.institucionais.cinzaSebrae45,
    dismissable: true,
    content: () => <p>{content}</p>,
    onChooseAction: (action) => actionsMap?.[action]?.(),
    onDismiss: () => onCancelClick(),
  };
  showModal(config);
}
